import React, { useState } from 'react';
import styles from './Accordion.module.postcss';

function Accordion({ children, theme, selectedIndex, ignoreHeight }) {
  const [activeIndex, setActiveIndex] = useState(selectedIndex);

  function onAccordionChange(index) {
    setActiveIndex(i => i === index ? null : index);
  }

  function renderChildren() {
    const result = [];
    React.Children.forEach(children, (child, index) => {
      if (child) {
        let newChild = React.cloneElement(child, {
          key: "accordion-item-" + index,
          index: index,
          isOpen: (activeIndex === index),
          onClick: () => onAccordionChange(index),
          ignoreHeight: ignoreHeight,
          theme: theme ? theme : styles,
        });
        result.push(newChild);
      }
    });
    return result;
  };

  return (
    <div className={theme ? theme.Accordion : styles.Accordion}>
      {renderChildren()}
    </div>
  );
};

export default Accordion;
